/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IAwardPeriodOption } from "Interfaces/SiteContent/IAwardPeriodOption";

import {
  AWARD_PERIOD_LOAD,
  AWARD_PERIOD_LOAD_FAILURE,
  AWARD_PERIOD_LOAD_SUCCESS,
} from "./AwardPeriodActionTypes";

/**
 * Action for getting the cl regions
 */
export interface IGetAwardPeriods {
  type: typeof AWARD_PERIOD_LOAD;
  tenant: string;
}

/**
 * Action getting the cl regions when successful
 */
export interface IGetAwardPeriodsSuccess {
  type: typeof AWARD_PERIOD_LOAD_SUCCESS;
  awardPeriods: IAwardPeriodOption[];
}

/**
 * Action getting the cl regions when failure
 */
export interface IGetAwardPeriodsFailure {
  type: typeof AWARD_PERIOD_LOAD_FAILURE;
  awardPeriodLoadError: string;
}

/**
 * Action creator for getting the cl regions
 */
export const getAwardPeriods = (tenant: string): IGetAwardPeriods => ({
  type: AWARD_PERIOD_LOAD,
  tenant,
});

/**
 * Action creator for getting cl regions when success
 * @param regions
 */
export const getAwardPeriodsSuccess = (
  awardPeriods: IAwardPeriodOption[]
): IGetAwardPeriodsSuccess => ({
  type: AWARD_PERIOD_LOAD_SUCCESS,
  awardPeriods,
});

/**
 * Action creator for getting cl regions when failure
 * @param regionsLoadError
 */
export const getAwardPeriodsFailure = (awardPeriodLoadError: string): IGetAwardPeriodsFailure => ({
  type: AWARD_PERIOD_LOAD_FAILURE,
  awardPeriodLoadError,
});

export type AwardPeriodActionTypes =
  | IGetAwardPeriods
  | IGetAwardPeriodsSuccess
  | IGetAwardPeriodsFailure;
